import React from 'react';
import Login from './view';
import { useLocation } from 'react-router-dom';
import * as queryString from 'query-string';
import { ENV } from '../../lib/const';

export const LoginContainer: React.FC = () => {
  const { search } = useLocation();
  const params = queryString.parse(search);
  const { redirect, error } = params;
  const onLogin = () => {
    const redirectString = redirect ? `?redirect=${redirect}` : '';
    window.location.href = `${ENV.routes.GOOGLE_AUTH_ROUTE}${redirectString}`;
  };

  return <Login onLogin={onLogin} error={error as string} />;
};

export default LoginContainer;
